import { NgModule } from '@angular/core';
import './df-api.interfaces';
import { RespectRedirectsService } from './response/respect-redirects.service';
import { RespectSessionNoticesService } from './response/respect-session-notices.service';

/**
 * @deprecated Use `provideDfApi` instead
 */
@NgModule()
export class DfApiModule {
    constructor(respectRedirectsService: RespectRedirectsService, respectSessionNoticesService: RespectSessionNoticesService) {
        respectRedirectsService.appInitialize();
        respectSessionNoticesService.appInitialize();
    }
}
